import Product from '@/Product';
import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';

export class ProductServiceStatic {
    getFullAccessProduct(): Promise<AxiosResponse<Product>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/fullaccessproduct`
        return AxiosPostProcessor.postProcess(Axios.get<Product>(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const ProductService = new ProductServiceStatic();
export default ProductService;
